/* Find My Pet — laser engraving text: cart editing, save to line item properties, checkout guard */
(function () {
  if (window.__fmpEngraving) return;
  window.__fmpEngraving = true;

  var L1 = 'Engraving line 1';
  var L2 = 'Engraving line 2';
  var L3 = 'Engraving line 3';
  var KEYS = [L1, L2, L3];
  function same(p, v) { p = p || {}; return KEYS.every(function (k, i) { return (p[k] || '') === (v[i] || ''); }); }
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  function clean(v) { return (v || '').replace(/\s+/g, ' ').trim(); }

  class FmpEngraving extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;
      this.inputs = Array.prototype.slice.call(this.querySelectorAll('input[data-line]'));
      this.statusEl = this.querySelector('[data-status]');
      this.queue = Promise.resolve();
      this.timer = null;
      var self = this;
      // keep Dawn's cart quantity handlers from seeing these inputs
      this.addEventListener('change', function (e) { e.stopPropagation(); self.save(); });
      this.addEventListener('input', function (e) {
        e.stopPropagation();
        self.classList.remove('fmp-engraving--error');
        clearTimeout(self.timer);
        self.timer = setTimeout(function () { self.save(); }, 700);
      });
      this.addEventListener('keydown', function (e) {
        if (e.key === 'Enter') { e.preventDefault(); e.stopPropagation(); e.target.blur(); }
      });
    }
    values() { return this.inputs.map(function (i) { return clean(i.value); }); }
    isValid() { return this.values()[0] !== ''; }
    showError() {
      this.classList.add('fmp-engraving--error');
      this.scrollIntoView({ block: 'center', behavior: 'smooth' });
      this.inputs[0].focus({ preventScroll: true });
    }
    setStatus(t) { if (this.statusEl) this.statusEl.textContent = t; }
    save() {
      clearTimeout(this.timer);
      var self = this;
      this.queue = this.queue.catch(function () {}).then(function () { return self._save(); });
      return this.queue;
    }
    _save() {
      var self = this;
      var v = this.values();
      var cached = {};
      try { cached = JSON.parse(this.dataset.props || '{}') || {}; } catch (e) { cached = {}; }
      if (!Array.isArray(cached) && same(cached, v)) return Promise.resolve();
      this.setStatus('Saving…');
      // read the live line first: hidden "__" properties (e.g. Kaching bundle tags) aren't exposed to Liquid
      return fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var line = null;
          cart.items.forEach(function (it) { if (!line && it.key === self.dataset.key) line = it; });
          if (!line) throw new Error('Line not found');
          var props = {};
          var src = line.properties || {};
          Object.keys(src).forEach(function (k) { props[k] = src[k]; });
          if (same(props, v)) return cart;
          KEYS.forEach(function (k, i) { delete props[k]; if (v[i]) props[k] = v[i]; });
          return fetch(root + 'cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ id: line.key, quantity: line.quantity, properties: props })
          }).then(function (r) { if (!r.ok) throw new Error('Save failed'); return r.json(); });
        })
        .then(function (cart) {
          var pos = -1;
          var item = null;
          cart.items.forEach(function (it, i) {
            if (item) return;
            if (String(it.variant_id) === self.dataset.variant && same(it.properties, v)) { item = it; pos = i + 1; }
          });
          if (!item) throw new Error('Line not found');
          self.dataset.key = item.key;
          self.dataset.props = JSON.stringify(item.properties || {});
          self.setStatus('Saved ✓');
          setTimeout(function () { if (self.statusEl && self.statusEl.textContent === 'Saved ✓') self.setStatus(''); }, 2000);
          // if Shopify moved the line, refresh Dawn's cart so its line numbers stay correct
          if (String(pos) !== self.dataset.index) {
            var ci = document.querySelector('cart-drawer-items') || document.querySelector('cart-items');
            if (ci && typeof ci.onCartUpdate === 'function') ci.onCartUpdate();
          }
        })
        .catch(function (err) {
          self.setStatus('Couldn’t save — please try again.');
          throw err;
        });
    }
  }
  if (!customElements.get('fmp-engraving')) customElements.define('fmp-engraving', FmpEngraving);

  function visibleEditors(scope) {
    var all = Array.prototype.slice.call((scope || document).querySelectorAll('fmp-engraving'));
    var vis = all.filter(function (el) { return el.getClientRects().length > 0; });
    return vis.length ? vis : all;
  }

  // Checkout guard (cart page + drawer)
  var bypass = false;
  document.addEventListener('click', function (e) {
    if (bypass) return;
    var btn = e.target.closest && e.target.closest('[name="checkout"], #CartDrawer-Checkout, #checkout');
    if (!btn) return;
    var scope = btn.closest('cart-drawer') || document.getElementById('MainContent') || document;
    var eds = visibleEditors(scope);
    if (!eds.length) return;
    var bad = eds.filter(function (el) { return !el.isValid(); });
    e.preventDefault();
    e.stopImmediatePropagation();
    if (bad.length) { bad[0].showError(); return; }
    btn.setAttribute('aria-busy', 'true');
    Promise.all(eds.map(function (el) { return el.save(); }))
      .then(function () {
        btn.removeAttribute('aria-busy');
        bypass = true;
        btn.click();
        bypass = false;
      })
      .catch(function () { btn.removeAttribute('aria-busy'); });
  }, true);

  // Product page: require line 1 before add to cart
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.elements) return;
    var fields = Array.prototype.slice.call(form.elements).filter(function (el) {
      return KEYS.some(function (k) { return el.name === 'properties[' + k + ']'; });
    });
    if (!fields.length) return;
    fields.forEach(function (el) { el.value = clean(el.value); });
    var req = fields.filter(function (el) { return el.hasAttribute('data-fmp-required') && !el.value; });
    if (req.length) {
      e.preventDefault();
      e.stopImmediatePropagation();
      var box = req[0].closest('[data-fmp-engraving-product]');
      if (box) box.classList.add('fmp-engraving--error');
      req[0].scrollIntoView({ block: 'center', behavior: 'smooth' });
      req[0].focus({ preventScroll: true });
    }
  }, true);

  document.addEventListener('input', function (e) {
    var box = e.target.closest && e.target.closest('[data-fmp-engraving-product]');
    if (box) box.classList.remove('fmp-engraving--error');
  });
})();
